import type { ReactElement } from "react";
import { CmtsSystemOperationsContainer } from "../../core/containers/domain/administrationRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsSystemOperationsContainer runtime={props.runtime} />;
}

export default Component;
